import { render, staticRenderFns } from "./TagsPopup.vue?vue&type=template&id=324dc109&scoped=true&"
import script from "./TagsPopup.vue?vue&type=script&lang=js&"
export * from "./TagsPopup.vue?vue&type=script&lang=js&"
import style0 from "./TagsPopup.vue?vue&type=style&index=0&id=324dc109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324dc109",
  null
  
)

export default component.exports